export default __webpack_public_path__ + "static/media/train_trainer_text.8b8d1862.svg";